import styled, { css, createGlobalStyle } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

const DisabledTabsStyle = css`
  opacity: 0.2;
  pointer-events: none;
`;

export const GlobalStyles = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.palette.system.white};
  }
`;

export const Page = styled.div`
  flex: 1;
  width: 100%;
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 30px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 15px;
  }
`;

export const Bookmarks = styled.div`
  width: 100%;
  margin: 0 auto 60px;
  max-width: 1280px;
`;

export const TabsWrapper = styled.div<{ $isDisabled: boolean }>`
  display: flex;
  height: 55px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  ${({ $isDisabled }) => $isDisabled && DisabledTabsStyle}
`;

export const SelectButton = styled(Button).attrs({
  borderRadius: 14,
  appearance: 'primaryOutlined',
})`
  height: 44px;
  padding: 0 26px;
  font-size: 16px;
  border: 0;
  user-select: none;
  border: 1px solid ${({ theme }) => theme.palette.brand.main};
`;

export const MobileSelectButton = styled(Button).attrs({
  borderRadius: 9,
  appearance: 'primaryText',
})`
  height: 30px;
  width: max-content;
  font-size: 14px;
  padding: 0 9px;

  svg {
    min-width: 13px;
  }
`;
